import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { AiMonitoringService } from '../services/monitoring.service';
import { GlobalErrorHandlerService } from '../services/global-error-handler.service';
import { HttpErrorInterceptor } from '../interceptors/http-error.interceptor';
import { TokenInterceptor } from '../interceptors/token.interceptor';
import { XWareLogService } from '../services/xware-log.service';
import { environment } from '../../environments/environment';

@NgModule({
  providers: [
    {
      provide: 'instrumentationKey',
      useValue: environment.appInsights.instrumentationKey,
    },
    {
      provide: 'appVersion',
      useValue: environment.appVersion,
    },
    {
      provide: 'portalapiurl',
      useValue: environment.portalapiurl,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    XWareLogService,
    AiMonitoringService,
  ],
  declarations: [],
  imports: [CommonModule],
})
export class CwCommonModule {}
